import React from 'react';

import PropTypes from 'prop-types';

import { formatUrl } from '../../../../utils/string.js';

import { callExternalLinkHandler } from '../../utils.jsx';

class ItemProfile extends React.Component {
  constructor(props) {
    super(props);
    this.handleClick = this.handleClick.bind(this);
  }
  handleClick(e, url) {
    // External link handler.
    callExternalLinkHandler(this.props.onExternalLinkClick, url, e);

    // prevent detail overlay from opening
    e.stopPropagation();
  }
  render() {
    const { avatar, username, handle, network, actions, originalHandle } = this.props;
    const profileLink = !!network && !!handle && network !== 'ugc' && formatUrl(`https://${network}.com/%s`, handle);
    return (
      <div className="xProfileWrapper">
        <div className="xProfileContainer">
          <If condition={avatar}>
            <div className="xUserAvatar">
              <If condition={profileLink}>
                <a
                  href={profileLink}
                  target="_blank"
                  onClick={e => {
                    this.handleClick(e, profileLink);
                  }}
                >
                  <img className="xAvatar" src={avatar} alt={username || handle} />
                </a>
              </If>
              <If condition={!profileLink}>
                <img className="xAvatar" src={avatar} alt={username || handle} />
              </If>
            </div>
          </If>
          <If condition={handle || username}>
            <div className="xUserDetails">
              <If condition={handle && profileLink}>
                <a
                  href={profileLink}
                  target="_blank"
                  onClick={e => {
                    this.handleClick(e, profileLink);
                  }}
                >
                  <div className="xUserHandle">{handle}</div>
                </a>
              </If>
              <If condition={handle && !profileLink}>
                <div className="xUserHandle">{handle}</div>
              </If>
              <If condition={username && profileLink}>
                <a
                  href={profileLink}
                  target="_blank"
                  onClick={e => {
                    this.handleClick(e, profileLink);
                  }}
                >
                  <div className="xUserName">{username}</div>
                </a>
              </If>
              <If condition={username && !profileLink}>
                <div className="xUserName">{username}</div>
              </If>
            </div>
          </If>
          <If condition={!!originalHandle}>
            <div className="xOriginalUser">
              <span className="xIcon xIconRetweetTwitter" />
              <span className="xOriginalHandle">Quoted Tweet from @{originalHandle}</span>
            </div>
          </If>
          {actions}
        </div>
      </div>
    );
  }
}

ItemProfile.propTypes = {
  avatar:              PropTypes.string,
  username:            PropTypes.string,
  handle:              PropTypes.string,
  actions:             PropTypes.object,
  network:             PropTypes.string,
  onExternalLinkClick: PropTypes.func,
  originalHandle:      PropTypes.string,
};

ItemProfile.defaultProps = {
  avatar:              undefined,
  username:            undefined,
  handle:              undefined,
  actions:             undefined,
  network:             undefined,
  onExternalLinkClick: undefined,
  originalHandle:      undefined,
};

export default ItemProfile;
